// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"docs-module--flexRow--2xaAo","label":"docs-module--label--u3Gz_"};